import { render, staticRenderFns } from "./DesemtranhamentoDocumento.vue?vue&type=template&id=07369b50"
import script from "./DesemtranhamentoDocumento.vue?vue&type=script&lang=js"
export * from "./DesemtranhamentoDocumento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports